var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"fb-root"}}),_c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb-customer-chat"}}),_c('Header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }